<p-toast />
<div class="flex items-center justify-center min-h-screen overflow-hidden container">
    <div class="bg-login flex justify-center items-center">
        <div class="w-full text-white">
            <div class="flex justify-center items-center">
                <img src="assets/icons/logo.png" width="300" height="300">
            </div>
        </div>
    </div>
    <div class="login-content border-2 bg-white">
        <div *ngIf="!visibleForgot">
            <div class="fs-25 fw-700 clr-black text-center">{{'LOGINHQ0013' | translate}}</div>
            <div class="mt-5">
                <label class="fs-14 fw-600 clr-gray">{{'LOGINHQ0016' | translate}}</label>
                <div class="flex mt-2">
                    <input type="text" [(ngModel)]="phonenumber" pInputText [maxlength]="14" inputmode="numeric"
                        (input)="onPhoneInput($event)" class="fs-16 fw-500 w-ffull clr-black" [ngClass]="{
                                'ng-invalid ng-dirty': phonenumber.length === 0 && submit
                            }">
                </div>
                <div>
                    <p *ngIf="phonenumber.length === 0 && submit" class="text-red-500 fs-12">{{'STOREHQ0041' |
                        translate}}</p>
                </div>
            </div>

            <div class="flex justify-center mt-5">
                <button pButton class="p-button-lg p-button-white w-full fs-14 fw-600"
                    (click)="find(findId)">{{'LOGINHQ0014' | translate}}</button>
                <button pButton class="p-button-lg p-button-white w-full fs-14 fw-600 ms-3"
                    (click)="find(findPass)">{{'LOGINHQ0015' | translate}}</button>
            </div>
            <div class="mt-3">
                <button pButton class="p-button-lg w-full fs-14 fw-600" (click)="redirectLogin()">{{'LOGINHQ0001' |
                    translate}}</button>
            </div>
        </div>

        <div *ngIf="visibleForgot">
            <div *ngIf="type == findId">
                <div class="fs-25 fw-700 clr-black text-center">{{'LOGINHQ0013' | translate}}</div>
                <div class="card flex justify-center items-center mt-5" style="height: 20vh;">
                    <div class="fs-14 fw-400 clr-black" [innerHTML]="'LOGINHQ0019' | translate:{ id: id }">
                    </div>
                </div>
                <div class="flex flex-col items-center mt-5">
                    <button pButton class="p-button-lg w-1/2 fs-14 fw-600" (click)="redirectLogin()">{{'LOGINHQ0020' |
                        translate}}</button>
                    <button pButton class="p-button-lg p-button-white w-1/2 fs-14 fw-600 mt-3"
                        (click)="type = findPass">{{'LOGINHQ0021' | translate}}</button>
                </div>
            </div>

            <div *ngIf="type == findPass">
                <div class="fs-25 fw-700 clr-black text-center">{{'LOGINHQ0022' | translate}}</div>
                <form [formGroup]="userForm" (submit)="changePass()">
                    <div class="mt-5">
                        <label for="password1"
                            class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2 fs-14 fw-500 clr-gray">{{'LOGINHQ0023'
                            | translate}}</label>
                        <p-password id="password1" placeholder="Password" [toggleMask]="true" formControlName="Password"
                            styleClass="fs-14 fw-500 clr-black" [fluid]="true" [feedback]="false"
                            [placeholder]="'LOGINHQ0024' | translate" [maxLength]="30"
                            [ngClass]="{ 'ng-invalid ng-dirty': userForm.get('Password')?.invalid && userForm.get('Password')?.touched}"></p-password>
                        <p *ngIf="userForm.get('Password')?.invalid && userForm.get('Password')?.touched"
                            class="text-red-500 fs-12">
                            {{'LOGINHQ0028' | translate}}
                        </p>
                    </div>

                    <div class="mt-3">
                        <label for="password1"
                            class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2 fs-14 fw-500 clr-gray"></label>
                        <p-password id="password1" formControlName="ConfirmPassword"
                            [placeholder]="'LOGINHQ0025' | translate" [toggleMask]="true"
                            styleClass="fs-14 fw-500 clr-black" [fluid]="true" [feedback]="false" [maxLength]="30"
                            [ngClass]="{ 'ng-invalid ng-dirty': userForm.get('ConfirmPassword')?.hasError('passwordMismatch') && userForm.get('ConfirmPassword')?.touched }"></p-password>
                        <p *ngIf="userForm.get('ConfirmPassword')?.hasError('passwordMismatch') && userForm.get('ConfirmPassword')?.touched"
                            class="text-red-500 fs-12">
                            {{'LOGINHQ0029' | translate}}
                        </p>
                    </div>

                    <div class="flex gap-3 items-center mt-5">
                        <button pButton class="p-button-lg p-button-white w-1/2 fs-14 fw-600"
                            (click)="redirectLogin()">{{'LOGINHQ0001' |
                            translate}}</button>
                        <button pButton type="button" class="p-button-lg p-button-white w-1/2 fs-14 fw-600"
                            (click)="type = findId">{{'LOGINHQ0014' | translate}}</button>
                    </div>
                    <div class="mt-3">
                        <button pButton type="submit" class="p-button-lg w-full fs-14 fw-600">{{'LOGINHQ0021' |
                            translate}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>